<template>
    <div>
        <report-list v-if="!mode" />
        <report-wizard v-else />
    </div>
</template>

<script>
import ReportList from "./list.vue";
import ReportWizard from "./wizard.vue";

export default {
    name: "totalReportV2",
    components: {
        ReportList,
        ReportWizard,
    },
    computed: {
        mode() {
            return this.$route.query.mode || "";
        },
    },
};
</script>
